module.exports = __webpack_public_path__ + "images/花筑pr长图_05.jpg?v=d5c67d9a";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu1/花筑pr长图_05.jpg
 ** module id = 20
 ** module chunks = 1 2
 **/